import { withStyles } from '@material-ui/core/styles';
import Spin from 'components/Spin';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bankslip } from 'store/Orbita/Subscriptions/actions';
import NoDangerouslyHTML from 'v2/components/Shared/NoDangerouslyHTML';

import type { DispatchProp } from 'react-redux';
import type { RouteComponentProps } from 'react-router-dom';

const styles = (theme: any) => ({
  root: theme.mixins.gutters({
    textAlign: 'center',
    minHeight: '70vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& h1': {
      fontSize: '2.5rem',
      lineHeight: '1.5rem',
      fontWeight: 600,
      color: '#596375',
    },
    '& h2': {
      fontSize: '1rem',
      color: '#596375',
    },
  }),
  pdf: {
    height: '150vh',
    width: '60%',
    overflow: 'hidden',
  },
});

interface IProps extends DispatchProp<any>, RouteComponentProps<any> {
  match: any;
  url: any;
  isFetching: boolean;
  classes: any;
}

interface IStates {
  message: string;
  loading: boolean;
}

class Bankslip extends React.Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      message: 'Estamos carregando seu boleto...',
      loading: true,
    };
  }

  componentDidMount() {
    let params = this.props.match.params;

    if (params && params.hash) {
      (async () => {
        try {
          await this.props.dispatch(bankslip(params.hash));
          this.setState({ loading: false });
        } catch {
          this.setState({ message: 'Não foi possível carregar o boleto', loading: false });
        }
      })();
    } else {
      this.setState({ message: 'Não foi possível carregar o boleto', loading: false });
    }
  }

  componentWillUnmount() {
    document.body.classList.remove('no-scroll');
  }

  render() {
    const { url, classes } = this.props;
    const { loading, message } = this.state;
    if (loading) {
      return (
        <div
          style={{
            width: '100%',
            height: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
          }}
        >
          <Spin width='60px' message={message} />
        </div>
      );
    } else if (url) {
      return (
        <div className={classes.root}>
          <NoDangerouslyHTML
            className={classes.pdf}
            html={`<iframe scrolling="no" frameborder="0" style="overflow:hidden;height:100%;width:100%" src="${url}" />`}
          />
        </div>
      );
    }
    return (
      <div className={classes.root}>
        <div className='notfound'>
          <h1>Erro</h1>
          <br />
          <h2>{message}</h2>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    url: state.orbita.Subscriptions.bankslip && state.orbita.Subscriptions.bankslip.url,
  };
}

export default withRouter(connect(mapStateToProps)(withStyles(styles)(Bankslip)));
